define("shared/components/shared/address-fields/item", ["exports", "@ember/component", "@ember/template-factory", "@glimmer/component", "@ember/service", "@ember/object", "@ember/utils"], function (_exports, _component, _templateFactory, _component2, _service, _object, _utils) {
  "use strict";

  Object.defineProperty(_exports, "__esModule", {
    value: true
  });
  _exports.default = void 0;

  var _class, _descriptor;

  0; //eaimeta@70e063a35619d71f0,"@glimmer/component",0,"@ember/service",0,"@ember/object",0,"@ember/utils",0,"@ember/template-factory"eaimeta@70e063a35619d71f

  function _initializerDefineProperty(target, property, descriptor, context) { if (!descriptor) return; Object.defineProperty(target, property, { enumerable: descriptor.enumerable, configurable: descriptor.configurable, writable: descriptor.writable, value: descriptor.initializer ? descriptor.initializer.call(context) : void 0 }); }

  function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

  function _applyDecoratedDescriptor(target, property, decorators, descriptor, context) { var desc = {}; Object.keys(descriptor).forEach(function (key) { desc[key] = descriptor[key]; }); desc.enumerable = !!desc.enumerable; desc.configurable = !!desc.configurable; if ('value' in desc || desc.initializer) { desc.writable = true; } desc = decorators.slice().reverse().reduce(function (desc, decorator) { return decorator(target, property, desc) || desc; }, desc); if (context && desc.initializer !== void 0) { desc.value = desc.initializer ? desc.initializer.call(context) : void 0; desc.initializer = undefined; } if (desc.initializer === void 0) { Object.defineProperty(target, property, desc); desc = null; } return desc; }

  function _initializerWarningHelper(descriptor, context) { throw new Error('Decorating class property failed. Please ensure that ' + 'proposal-class-properties is enabled and runs after the decorators transform.'); }

  const __COLOCATED_TEMPLATE__ = (0, _templateFactory.createTemplateFactory)(
  /*
    <Input
    data-test-id="address-form-item"
    class={{concat-classes "o--form__input" @qaClass (if (or this.showEmptyError (is-present this.suggestion)) "o--form__input--hasError") (if @isDisabled "u--mute")}}
    @disabled={{@isDisabled}}
    @type="text"
    @placeholder={{@placeHolder}}
    @value={{@value}}
    {{on "keyup" this.clearSuggestion}}
    {{on "change" this.clearSuggestion}}
  />
  <Shared::AddressFields::Error
    @emptyText={{@emptyText}}
    @invalidText={{@invalidText}}
    @field={{@field}}
    @missingValue={{this.showEmptyError}}
    @suggestion={{this.suggestion}}
    @setSuggestion={{@setSuggestion}}
  />
  
  */
  {
    "id": "Dk1RByW9",
    "block": "[[[8,[39,0],[[24,\"data-test-id\",\"address-form-item\"],[16,0,[28,[37,1],[\"o--form__input\",[30,1],[52,[28,[37,3],[[30,0,[\"showEmptyError\"]],[28,[37,4],[[30,0,[\"suggestion\"]]],null]],null],\"o--form__input--hasError\"],[52,[30,2],\"u--mute\"]],null]],[4,[38,5],[\"keyup\",[30,0,[\"clearSuggestion\"]]],null],[4,[38,5],[\"change\",[30,0,[\"clearSuggestion\"]]],null]],[[\"@disabled\",\"@type\",\"@placeholder\",\"@value\"],[[30,2],\"text\",[30,3],[30,4]]],null],[1,\"\\n\"],[8,[39,6],null,[[\"@emptyText\",\"@invalidText\",\"@field\",\"@missingValue\",\"@suggestion\",\"@setSuggestion\"],[[30,5],[30,6],[30,7],[30,0,[\"showEmptyError\"]],[30,0,[\"suggestion\"]],[30,8]]],null],[1,\"\\n\"]],[\"@qaClass\",\"@isDisabled\",\"@placeHolder\",\"@value\",\"@emptyText\",\"@invalidText\",\"@field\",\"@setSuggestion\"],false,[\"input\",\"concat-classes\",\"if\",\"or\",\"is-present\",\"on\",\"shared/address-fields/error\"]]",
    "moduleName": "shared/components/shared/address-fields/item.hbs",
    "isStrictMode": false
  });

  /**
   * @class Shared::AddressFields::Item
   * @extends Component
   *
   * This component is an address form for a user to enter their street address
   * On submit of the form it will validate each field for the given address
   *
   *  Required Arguments:
   *
   * - [invalidText] (String) string text of error to show if field is deemed invalid by API.
   * - [placeHolder] (String) string text of placeholder for input.
   * - [field] (String) name of the field. used for searching for outstanding suggestions
   * - [showError] (Boolean) Used to determine whether or not to show errors. Will be false for an optional field
   * - [qaClass] (String) QA class to attach to the input
   * - [value] (String) Value inputed into input
   *
   *  Optional Arguments
   * - [emptyText] (String) string text of error to show if field is empty. Optional because if showError is false, it does not require it
   * - [isRequired] (Boolean) Used to determined if error should be shown when field is empty.
   *
   * Inline Usage with all options:
   * ```
   *<Shared::AddressFields::Item
   *  @emptyText={{t "Missing City"}}
   *  @invalidText={{"couldn't find that city, maybe it doesn't exist"}}
   *  @placeHolder={{"Enter a City"}}
   *  @field={{"city"}}
   *  @qaClass={{"qa--address_city__input"}}
   *  @showErrors={{true}}
   *  @value={{'Calgary'}}
   *  @isRequired={{true}}
   * />
   * ```
   */
  let AddressItem = (_class = class AddressItem extends _component2.default {
    constructor() {
      super(...arguments);

      _initializerDefineProperty(this, "address", _descriptor, this);
    }

    get showEmptyError() {
      return this.args.isRequired && this.args.showErrors && !(0, _utils.isPresent)(this.args.value);
    }

    get suggestion() {
      return this.address.suggestedChanges.find(item => item.key === this.args.field);
    }

    clearSuggestion() {
      this.address.resetValidation();

      if ((0, _utils.isPresent)(this.suggestion)) {
        this.address.clearSuggestion(this.args.field);
      }
    }

  }, (_descriptor = _applyDecoratedDescriptor(_class.prototype, "address", [_service.inject], {
    configurable: true,
    enumerable: true,
    writable: true,
    initializer: null
  }), _applyDecoratedDescriptor(_class.prototype, "clearSuggestion", [_object.action], Object.getOwnPropertyDescriptor(_class.prototype, "clearSuggestion"), _class.prototype)), _class);
  _exports.default = AddressItem;
  (0, _component.setComponentTemplate)(__COLOCATED_TEMPLATE__, AddressItem);
});